export const throttle = (callback, wait) => {
  let time = Date.now();
  return function () {
    if (!(time + wait - Date.now() < 0)) return;
    callback();
    time = Date.now();
  };
};
